import { revFY24_01Classifier } from './fy24_01';
import { revFY25_01Classifier } from './fy25_01';
var Revisions = [{
  name: 'fy24.01',
  classifier: revFY24_01Classifier
}, {
  name: 'fy25.01',
  classifier: revFY25_01Classifier
}];
var revisionResultCache = null;
export var getRevisions = function getRevisions() {
  if (revisionResultCache !== null) {
    return revisionResultCache;
  }
  revisionResultCache = [].concat(Revisions);
  return revisionResultCache;
};